module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor__ghost"
  }, [_c('div', {
    staticClass: "highlights",
    attrs: {
      "id": "highlights"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bdfa504!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor/EditorHighlight.vue
// module id = 2151
// module chunks = 0